(function () {
  "use strict";

  var COOKIE_NAME = "wc_popup_herba";
  var POPUP_ID = "wc_herba_popup";
  var CONTAINER_ID = "herbalifepopup";

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function wcSetSessionCookie(cname, cvalue) {
    var cookie =
      encodeURIComponent(cname) +
      "=" +
      encodeURIComponent(cvalue) +
      ";path=/;SameSite=Lax";

    if (window.location.protocol === "https:") {
      cookie += ";Secure";
    }

    document.cookie = cookie;
  }

  function wcGetCookie(cname) {
    var name = encodeURIComponent(cname) + "=";
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(name) === 0) {
        return decodeURIComponent(
          cookie.substring(name.length),
        );
      }
    }

    return "";
  }

  window.wcHidePopUp = function (event) {
    if (event) {
      event.preventDefault();
    }

    var popup = document.getElementById(POPUP_ID);

    if (popup) {
      popup.style.display = "none";
    }

    return false;
  };

  function getPopupHtml(distributorName) {
    var safeDistributorName =
      escapeHtml(distributorName);

    return `
      <style>
        html {
          font-family: sans-serif;
          line-height: 1.15;
          -ms-text-size-adjust: 100%;
          -webkit-text-size-adjust: 100%;
        }

        body {
          margin: 0;
          font-family: 'Helvetica', 'Arial', sans-serif !important;
        }

        #${CONTAINER_ID} p {
          margin: 0.5em;
        }

        #${CONTAINER_ID} p.para-lead {
          font-size: 1.2em;
          margin: 0.75em;
        }

        #${CONTAINER_ID} a {
          background-color: transparent;
          -webkit-text-decoration-skip: objects;
        }

        #${CONTAINER_ID} a:active,
        #${CONTAINER_ID} a:hover {
          outline-width: 0;
        }

        #${CONTAINER_ID} p,
        #${CONTAINER_ID} h1 {
          font-family: 'Helvetica', 'Arial', sans-serif !important;
          color: #6c6d70 !important;
        }

        .herbalife-popup {
          position: fixed !important;
          top: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          left: 0 !important;
          z-index: 999999 !important;
          text-align: center !important;
          display: none;
          color: #6c6d70 !important;
        }

        .herbalife-bg {
          position: absolute !important;
          top: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          left: 0 !important;
          background: #000 !important;
          opacity: 0.9 !important;
          z-index: 999998 !important;
        }

        .herbalife-wrap {
          min-width: 400px !important;
          height: auto !important;
          max-height: 100% !important;
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          z-index: 999999 !important;
          transform: translate(-50%, -50%) !important;
          margin: 0 auto !important;
          color: #6c6d70 !important;
        }

        .herbalife-content {
          position: relative !important;
          display: inline-block !important;
          padding: 15px !important;
          background: #fff !important;
          color: #6c6d70 !important;
        }

        .herbalife-info {
          position: relative !important;
          float: left !important;
          padding: 15px !important;
          border: 3px solid #7ac142 !important;
          color: #6c6d70 !important;
        }

        .herbalife-info h1 {
          width: calc(100% - 2rem) !important;
          margin: 0 0 15px 0 !important;
          padding: 0 !important;
          font-size: 18px !important;
          line-height: 1em !important;
          font-weight: bold !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .herbalife-close {
          position: absolute !important;
          top: 5px !important;
          right: 10px !important;
          background: #7ac142 !important;
          border-radius: 50% !important;
          font-size: 12px !important;
          font-weight: bold !important;
          color: #fff !important;
          padding: 8px !important;
          text-decoration: none !important;
          text-align: center !important;
          cursor: pointer !important;
          line-height: 8px !important;
        }

        .herbalife-info .herbalife-close:hover {
          background: #6c6d70 !important;
        }

        .herbalife-info .herbalife-row {
          position: relative !important;
          float: left !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .left-col {
          width: 60% !important;
          position: relative !important;
          float: left !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .left-col.border {
          width: calc(60% - 16px) !important;
          padding: 0 15px 0 0 !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .left-col img {
          max-width: 100% !important;
          height: auto !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .left-col img.f-right {
          float: right !important;
          margin: 10px 0 0 0 !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .right-col {
          width: 40% !important;
          position: relative !important;
          float: left !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .right-col.border {
          width: calc(40% - 15px) !important;
          padding: 0 0 0 15px !important;
          color: #6c6d70 !important;
          border-left: 1px solid #7ac142 !important;
        }

        .herbalife-info .right-col p.copy {
          margin: 15px 0 0 0 !important;
          font-size: 14px !important;
          line-height: 13px !important;
          color: #6c6d70 !important;
        }

        .herbalife-info .right-col p span {
          color: #7ac142 !important;
        }

        .herbalife-info p a {
          font-weight: bold !important;
          text-decoration: none !important;
          color: #6c6d70 !important;
        }

        .clear {
          height: 0 !important;
          line-height: 0 !important;
          clear: both !important;
        }

        @media screen and (max-width: 767px) {
          .herbalife-wrap {
            overflow-y: auto;
            min-width: 90% !important;
          }

          .herbalife-info .left-col,
          .herbalife-info .right-col,
          .herbalife-info .left-col.border,
          .herbalife-info .right-col.border {
            width: 100% !important;
            margin: 0 0 10px 0 !important;
            padding: 0 !important;
            border: 0 !important;
          }

          .herbalife-info .left-col.border {
            text-align: center !important;
          }

          .herbalife-info h1 {
            font-size: 0.95em !important;
            line-height: 1.2em !important;
          }

          #${CONTAINER_ID} .herbalife-info .right-col,
          #${CONTAINER_ID} .herbalife-info .right-col.border {
            margin: 0 !important;
          }

          #${CONTAINER_ID} .herbalife-info .left-col {
            margin: 0 !important;
          }

          .herbalife-info .left-col img.f-right {
            float: left !important;
            margin: 5px 0 0 0 !important;
          }

          #${CONTAINER_ID} .para-lead {
            font-size: 1em !important;
          }

          #${CONTAINER_ID} p {
            font-size: 0.85em;
            line-height: 1.4em !important;
          }
        }

        @media screen and (min-width: 768px) {
          .herbalife-wrap {
            min-width: 768px !important;
          }
        }

        @media screen and (min-width: 850px) {
          .herbalife-wrap {
            min-width: 850px !important;
          }
        }

        /* Solace: versione più compatta del popup Herbalife */

.herbalife-wrap {
  width: calc(100vw - 40px) !important;
  max-width: 760px !important;
  min-width: 0 !important;
}

.herbalife-content {
  width: 100% !important;
  padding: 10px !important;
}

.herbalife-info {
  width: 100% !important;
  padding: 16px !important;
}

.herbalife-info h1 {
  font-size: 16px !important;
  line-height: 1.08 !important;
  margin-bottom: 10px !important;
}

#herbalifepopup .para-lead {
  margin: 4px 36px 22px !important;
  font-size: 15px !important;
  line-height: 1.4 !important;
}

#herbalifepopup .herbalife-info p {
  font-size: 14px !important;
  line-height: 1.45 !important;
  margin: 6px 0 !important;
}

.herbalife-info .left-col.border {
  width: calc(60% - 13px) !important;
  padding-right: 12px !important;
}

.herbalife-info .right-col.border {
  width: calc(40% - 12px) !important;
  padding-left: 12px !important;
}

/* Pulsante chiusura più facile da premere */
.herbalife-info .herbalife-close {
  top: 7px !important;
  right: 7px !important;

  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  font-size: 15px !important;
  line-height: 1 !important;
}

/* Mobile */
@media screen and (max-width: 767px) {
  .herbalife-wrap {
    width: calc(100vw - 24px) !important;
    max-width: 520px !important;
  }

  .herbalife-content {
    padding: 8px !important;
  }

  .herbalife-info {
    padding: 14px !important;
  }

  #herbalifepopup .para-lead {
    margin: 4px 30px 18px !important;
    font-size: 14px !important;
  }

  #herbalifepopup .herbalife-info p {
    font-size: 13px !important;
    line-height: 1.4 !important;
  }

  .herbalife-info h1 {
    font-size: 14px !important;
  }

  .herbalife-info .herbalife-close {
    width: 32px !important;
    height: 32px !important;
  }
 }
  #herbalifepopup .herbalife-row {
  margin-top: 14px !important;
}
      </style>

      <div
        class="herbalife-popup"
        id="${POPUP_ID}"
        role="dialog"
        aria-modal="true"
        aria-labelledby="herbalife-popup-title"
      >
        <div class="herbalife-bg">&nbsp;</div>

        <div class="herbalife-wrap">
          <div class="herbalife-content">
            <div class="herbalife-info">

              <a
                class="herbalife-close"
                href="#"
                aria-label="Chiudi"
                onclick="return wcHidePopUp(event)"
              >
                x
              </a>

              <p
                class="para-lead"
                id="herbalife-popup-title"
              >
                Questo sito web è gestito dal Distributore Indipendente Herbalife: ${safeDistributorName}
              </p>

              <div class="herbalife-row">

                <div class="left-col border">
                  <h1>
                    SEI GIÀ UN CLIENTE?
                  </h1>

                  <p>
                    La relazione personale con il tuo Distributore è la chiave per raggiungere i tuoi obiettivi nutrizionali. Se ${safeDistributorName} non è il Distributore che ti segue, ti invitiamo ad acquistare i tuoi prodotti dal Distributore con cui sei già in contatto. In alternativa,
                    <a
                      href="#"
                      onclick="return wcHidePopUp(event)"
                    >
                      clicca qui
                    </a>
                    per continuare su questo sito web.
                  </p>
                </div>

                <div class="right-col border">
                  <h1>
                    SEI GIÀ UN DISTRIBUTORE o un CLIENTE PRIVILEGIATO HERBALIFE?
                  </h1>

                  <p>
                    Per acquistare i prodotti con il tuo codice vai su
                    <a href="https://www.myherbalife.com/it-IT">
                      myherbalife.com
                    </a>
                  </p>
                </div>

              </div>

              <div class="clear">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  async function getConsultantName() {
  /*
   * Caso 1:
   * il consulente è già stato caricato.
   */
  if (window.SolaceConsultant) {
    const name = String(
      window.SolaceConsultant.public_name || ""
    ).trim();

    if (name) {
      return name;
    }
  }

  /*
   * Caso 2:
   * il loader Solace sta ancora lavorando.
   * Aspettiamo direttamente la Promise che
   * usa già la pagina.
   */
  if (
    window.SolaceConsultantPromise &&
    typeof window.SolaceConsultantPromise.then === "function"
  ) {
    const consultant =
      await window.SolaceConsultantPromise;

    if (!consultant) {
      throw new Error(
        "Consulente Solace non disponibile."
      );
    }

    const name = String(
      consultant.public_name || ""
    ).trim();

    if (!name) {
      throw new Error(
        "Nome pubblico del Distributore non disponibile."
      );
    }

    return name;
  }

  /*
   * Caso 3:
   * per robustezza, se lo script popup viene
   * eseguito prima che il loader abbia creato
   * la Promise, aspettiamo l'evento ufficiale
   * già emesso da Solace.
   */
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener(
        "solace:consultant-ready",
        handleConsultantReady
      );

      reject(
        new Error(
          "Timeout durante il caricamento del Distributore."
        )
      );
    }, 10000);

    function handleConsultantReady(event) {
      window.clearTimeout(timeout);

      const consultant =
        event?.detail ||
        window.SolaceConsultant;

      const name = String(
        consultant?.public_name || ""
      ).trim();

      if (!name) {
        reject(
          new Error(
            "Nome pubblico del Distributore non disponibile."
          )
        );

        return;
      }

      resolve(name);
    }

    window.addEventListener(
      "solace:consultant-ready",
      handleConsultantReady,
      {
        once: true
      }
    );
  });
 }
  

  async function initHerbalifePopup() {
    /*
     * Se il popup è già stato mostrato
     * nella sessione corrente, non serve
     * interrogare nuovamente Supabase.
     */
    if (wcGetCookie(COOKIE_NAME) === "shown") {
      return;
    }

    var container =
      document.getElementById(CONTAINER_ID);

    if (!container) {
      console.error(
        "Herbalife popup container not found.",
      );

      return;
    }

    try {
      var distributorName =
        await getConsultantName();

      container.innerHTML =
        getPopupHtml(distributorName);

      var popup =
        document.getElementById(POPUP_ID);

      if (!popup) {
        throw new Error(
          "Popup Herbalife non creato.",
        );
      }

      popup.style.display = "block";

      /*
       * Il file Herbalife originale imposta
       * il cookie nel momento in cui il popup
       * viene mostrato.
       *
       * Manteniamo lo stesso comportamento,
       * usando intenzionalmente un cookie
       * di sessione.
       */
      wcSetSessionCookie(
        COOKIE_NAME,
        "shown",
      );
    } catch (error) {
      console.error(
        "Herbalife popup initialization error:",
        error,
      );
    }
  }

  /*
   * Con "defer" il DOM dovrebbe essere
   * già disponibile. Questo controllo
   * mantiene comunque lo script robusto
   * anche se in futuro viene spostato.
   */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initHerbalifePopup,
      {
        once: true,
      },
    );
  } else {
    initHerbalifePopup();
  }
})();